module.exports = __webpack_public_path__ + "components/page-header/static/icon-heart-fill-c4a0599c53714fe729ed6d659d69bea4.svg";